import { getQueryVariable } from './queryParams';

const OnboardingType = {
  SYSTEM2: 'SYSTEM2',
  EXTERNAL: 'EXTERNAL',
};

const externalCoach = getQueryVariable('externalCoach');

// User's anon id
const anonId = getQueryVariable('anonid');

const planCode = getQueryVariable('plan');

const leadId = getQueryVariable('leadId');

const contractId = getQueryVariable('contractId');

/*
  The 1:1 upsell A/B test, as the challenge's landing page hands it over, under short names that don't spell out the
  test on the link: which arm the visitor is in (`ua`) and, in the landing arm, whether they accepted the 1:1 there
  (`u`). Read as-is here; utils/upsellExperiment decides what their codes mean.
*/
const upsellArmParam = getQueryVariable('ua');

const upsellAnswerParam = getQueryVariable('u');

export {
  OnboardingType,
  externalCoach,
  anonId,
  planCode,
  leadId,
  contractId,
  upsellArmParam,
  upsellAnswerParam,
};
